function shapeTop() {
	var $shapes = $('.js-shape-top');

	$shapes.each(function() {
		$(this).css({
			'height' : ww/shapeRatio,
			'top' : -ww/shapeRatio,
		});
	});
}

function shapeBottom() {
	var $shapes = $('.js-shape-bottom');

	$shapes.each(function() {
		if($(this).hasClass('js-header-shape')) {
			$(this).css({
				'height' : ww/shapeRatio - 2,
				// 'top' : -ww/shapeRatio - 2,
			});
		} else {
			$(this).css({
				'height' : ww/shapeRatio,
				// 'top' : ww/shapeRatio - 1,
			});
		}

	});
}

function shapeBottomSize() {
	var $block = $('.js-last-block');
	var $lastShape = $('.js-last-shape').height();

	if($lastShape < 90) {

		$block.css('padding-bottom', (90 - $lastShape) + 'px');

	} else {

		var blockChildren = $block.children(),
			$lastChild = $(blockChildren[blockChildren.length-1]),
			$lastShapeExcess = $lastShape - 90;

		$lastChild.css({
			'margin-bottom' : -$lastShapeExcess + 'px',
			// 'display' : 'inline-block',
		});
	}

}

function bgCover() {
	$(window).scroll(function() {
		var scrolledY = $(window).scrollTop();
		$('.cover-img').css('background-position', 'top ' + ((scrolledY)) + 'px');
	});
}
